import React, { FC, useEffect } from 'react';
import cn from 'classnames/bind';

import { Toast } from '../Toast/Toast';
import ToastIcon from '../../assets/ToastIcon';
import { ToastNotification as ToastModel } from '../../lib/popups';

import styles from './ToastNotification.module.css';

const cx = cn.bind(styles);

interface ToastNotificationProps extends ToastModel {
    onHide: VoidFunction;
}

export const ToastNotification: FC<ToastNotificationProps> = ({
    type,
    message,
    viewVariant = 'BOTTOM',
    showTime = 12,
    onHide,
}) => {
    useEffect(() => {
        const timeout = window.setTimeout(onHide, showTime * 1000);

        return () => {
            clearTimeout(timeout);
        };
    }, [onHide, showTime]);

    return (
        <button
            className={cx('root', {
                rootBottom: viewVariant === 'BOTTOM',
                rootTop: viewVariant === 'TOP',
                rootBottomDark: viewVariant === 'BOTTOMDARK',
                rootTopDark: viewVariant === 'TOPDARK',
            })}
            onClick={onHide}
            type="button"
        >
            <Toast className={cx('theme')}>
                <ToastIcon type={type} className={cx('logo')} />
                <div className={cx('message')}>{message}</div>
            </Toast>
        </button>
    );
};
